<div style="float: right; padding-right: 15px;">
    <button type="button" class="btn btn-primary" (click)="add()">{{'FUNCTION-BUTTONS.SAVE' | translate}}</button>
</div>
<br/>
<br/><br/>